/**
 * @fileoverview Pre-appointment pipeline status type options (MOR-882)
 *
 * The three semantic "types" a firm-defined pipeline stage can map to. Local
 * equivalent of the task managers' status-types helper so the Pre-Appointment
 * Statuses manager (and any future quick-add surface) describe types
 * identically.
 */

import type { PreAppointmentStatusType } from "@cvx/preAppointment/preAppointmentStatuses/schema";

export const STATUS_TYPE_OPTIONS: ReadonlyArray<{
  value: PreAppointmentStatusType;
  label: string;
  hint: string;
}> = [
  { value: "open", label: "Open", hint: "Pitch in play" },
  { value: "won", label: "Won", hint: "Converted to appointment" },
  { value: "lost", label: "Lost", hint: "Did not proceed" },
];
